import React, { setGlobal } from 'reactn';
import ReactDOM from 'react-dom';
import ConfirmForm from './ConfirmForm';

(async () => {
    const appContainer = document.querySelector('[data-confirmation-form]');

    await setGlobal({
        step: 1,
        bookingId: null,
        bookingType: null,
        bookingAdults: '',
        bookingChildren: '',
        roomNumber: '',
        outsideRestaurant: false,
        searchResult: {},
        loading: false,
        packageTypes: [],
    });

    if (appContainer) {
        ReactDOM.render(<ConfirmForm />, appContainer);
    }
})();
